module.exports = __webpack_public_path__ + "static/icon-competitive-3.faf2ddb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-competitive-3.svg
// module id = 195
// module chunks = 35783957827783 267625579013595